<p-tabView [(activeIndex)]="activeIndex">
    <p-tabPanel class="mb-2" [disabled]="disabledInputs" header="Inputs used in calculation">
        <app-eea-output-project-pelmo-run-inputs-inputs-use-in-calculation [selectedModel]="selectedModel" *ngIf="!disabledInputs"
            [selectedProject]="selectedProject"></app-eea-output-project-pelmo-run-inputs-inputs-use-in-calculation>
    </p-tabPanel>
    <p-tabPanel class="mb-2" [disabled]="disabledSummary" header="Summary of the results ">
        <eea-output-project-pelmo-result-summary [selectedModel]="selectedModel" *ngIf="!disabledSummary"
            [selectedProject]="selectedProject"></eea-output-project-pelmo-result-summary>
    </p-tabPanel>
</p-tabView>